var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { DefaultSkin } from '../../types/Skin';
var LegendBoxBase = function (props) {
    return React.createElement("div", { className: props.className },
        React.createElement(Box, null),
        props.label && React.createElement(Label, null, props.label));
};
var Box = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Size */\n  width:  10px;\n  height: 10px;\n  /* Appearance */\n  border: solid 1px black;\n  border-radius: 2px;\n  transition: border-color ease-in-out 150ms;\n  flex-shrink: 0;\n  &:hover {\n    border-color: white;\n  }\n"], ["\n  /* Size */\n  width:  10px;\n  height: 10px;\n  /* Appearance */\n  border: solid 1px black;\n  border-radius: 2px;\n  transition: border-color ease-in-out 150ms;\n  flex-shrink: 0;\n  &:hover {\n    border-color: white;\n  }\n"])));
var Label = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #fff;\n  user-select: none;\n"], ["\n  color: #fff;\n  user-select: none;\n"])));
var LegendBoxStyled = styled(LegendBoxBase).attrs(function (p) {
    var _a;
    return ({
        skin: (_a = p.skin) !== null && _a !== void 0 ? _a : DefaultSkin
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  ", " {\n    background-color: ", ";\n  }\n  ", " {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  ", " {\n    background-color: ", ";\n  }\n  ", " {\n    color: ", ";\n  }\n"
    /**
     * A small, colored square box.
     */
])), Box, function (p) { return p.color; }, Label, function (p) { return p.skin.border; });
/**
 * A small, colored square box.
 */
var LegendBox = function (p) { return React.createElement(LegendBoxStyled, __assign({}, p)); };
export { LegendBox };
var templateObject_1, templateObject_2, templateObject_3;
